module.exports = __webpack_public_path__ + "static/media/Relative-Book-Web.ac69cf5d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Book-Web.eot
// module id = 739
// module chunks = 0